import { getEnvironment } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';
import { getLocationSearch } from './getLocationSearch.tsx';

const isNonProductionEnvironment = (): boolean => {
	const environment = getEnvironment();
	return environment === 'staging' || environment === 'dev' || environment === 'local';
};

export const isStableUIEnabledForTests = (): boolean => {
	if (!fg('jpx-870-stable-ui-for-criterion')) {
		return false;
	}

	if (!isNonProductionEnvironment()) {
		return false;
	}

	if (killswitch('jira_stable_ui_for_tests')) {
		return false;
	}

	return getLocationSearch().includes('stableUI=1');
};
